import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { ModelSizesTable } from '../components';
import { ModelSize } from '../types';

export const ModelSizesPage: FC = () => {
  const navigate = useNavigate();

  const redirectToModelSize = (item: ModelSize) => {
    navigate(Routes.ModelSizeDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Model Sizes"
        actions={[
          <Link
            to={Routes.NewModelSize}
            key="new-model-size"
            data-testid="add-new-model-size-link"
          >
            <Button data-testid="add-new-model-size-button">
              <PlusSquareIcon />
              Add new size
            </Button>
          </Link>,
        ]}
      />

      <ModelSizesTable onClick={redirectToModelSize} />
    </div>
  );
};
